import React, {Component} from "react";
import "./PublicForm.css";
import {Wizard} from "../../../components";
import ValidationUtil from "../../../components/form/validator/ValidationUtil";
import RemotingService from "../../../services/remoting-service/RemotingService";
import DateUtil from "../../../utils/DateUtil";
import moment from "moment";
import confirmDialog from "../../../components/dialog/ConfirmDialog";
import IntakeFormRadTextEnum from "../intakeformrad/enum/IntakeFormRadTextEnum";
import IntakeFormRadPersonalInformation from "../intakeformrad/IntakeFormRadPersonalInformation";
import IntakeFormRadContactInformation from "../intakeformrad/IntakeFormRadContactInformation";
import IntakeFormRadReferralInformation from "../intakeformrad/IntakeFormRadReferralInformation";
import IntakeFormRadEmergencyContact from "../intakeformrad/IntakeFormRadEmergencyContact";
import IntakeFormRadHealthHistory from "../intakeformrad/IntakeFormRadHealthHistory";
import ConsentFormPartsRad from "../utils/ConsentFormPartsRad";
import InformedConsentFormRadTextEnum from "../informedconsent/enum/InformedConsentFormRadTextEnum";
import InformedConsentSignatureInputs from "../informedconsent/InformedConsentSignatureInputs";
import CancellationPolicyPartsDxb from "../cancellationpolicy/CancellationPolicyPartsDxb";
import CancellationPolicyDxbTextEnum from "../cancellationpolicy/enum/CancellationPolicyDxbTextEnum";
import NabidhConsentFormParts from "../nabidh/NabidhConsentFormParts";
import NabidhFormTextEnum from "../NabidhFormTextEnum";
import PatientUtil from "../../../utils/PatientUtil";
import StringUtil from "../../../utils/StringUtil";
import ClinicLogo from "../../../layout/ClinicLogo";
import {connect} from "react-redux";
import LookupService from "../../../services/lookup/LookupService";

class PublicNewPatientFormRad extends Component {
    constructor(props) {
        super(props);

        this.state = {
            patientSignature: null,
            witnessSignature: null,
            nabidhConsentAction: null,
            nabidhPatientSignature: null,
            nabidhWitnessName: "",
            nabidhWitnessSignature: null,
            nabidhRelationshipToPatient: "",
        };
    }

    componentDidMount() {
        this.retrievePatientPhoto();

        const {form} = this.props;

        if (form.consentForIntakeFormRad.dob && !form.consentForIntakeFormRad.age) {
            form.consentForIntakeFormRad.age = DateUtil.getAgeWithMonths(moment(form.consentForIntakeFormRad.dob));
        }

        // Ensure allergy object is initialized to maintain reference with FormAllergiesSection
        if (!form.consentForIntakeFormRad.allergy) {
            form.consentForIntakeFormRad.allergy = {};
        }

        if (form.consentForInformedConsentRad.patientSignature) {
            this.setState({patientSignature: form.consentForInformedConsentRad.patientSignature});
        }

        if (form.consentForInformedConsentRad.witnessSignature) {
            this.setState({witnessSignature: form.consentForInformedConsentRad.witnessSignature});
        }

        // Initialize Nabidh consent fields if not present
        if (!form.nabidhConsent) {
            form.nabidhConsent = {
                consentType: null,
                patientSignature: null,
                witnessName: "",
                witnessSignature: null,
                relationshipToPatient: ""
            };
        }
        
        this.setState({
            nabidhConsentAction: form.nabidhConsent.consentType || null,
            nabidhPatientSignature: form.nabidhConsent.patientSignature || null,
            nabidhWitnessName: form.nabidhConsent.witnessName || "",
            nabidhWitnessSignature: form.nabidhConsent.witnessSignature || null,
            nabidhRelationshipToPatient: form.nabidhConsent.relationshipToPatient || ""
        });

        // Match lookup objects from Redux store for SelectInput compatibility
        this.matchLookupObjects(form.consentForIntakeFormRad);

        this.forceUpdate();
    }

    matchLookupObjects = (form) => {
        const {relationshipTypes, nationalities, countries, maritalStatuses, religions, languages} = this.props;

        // Match emergency contact relationship type
        const relationshipTypeObject = LookupService.matchLookupObject(
            form.emergencyContactRelationshipType,
            relationshipTypes
        );
        if (relationshipTypeObject) {
            form.emergencyContactRelationshipType = relationshipTypeObject;
        }

        // Match nationality lookup field
        const nationalityObject = LookupService.matchLookupObject(
            form.nationality,
            nationalities
        );
        if (nationalityObject) {
            form.nationality = nationalityObject;
        }

        // Match country lookup field
        const countryObject = LookupService.matchLookupObject(
            form.country,
            countries
        );
        if (countryObject) {
            form.country = countryObject;
        }

        // Match marital status lookup field
        const maritalStatusObject = LookupService.matchLookupObject(
            form.maritalStatus,
            maritalStatuses
        );
        if (maritalStatusObject) {
            form.maritalStatus = maritalStatusObject;
        }

        // Match religion lookup field
        const religionObject = LookupService.matchLookupObject(
            form.religion,
            religions
        );
        if (religionObject) {
            form.religion = religionObject;
        }

        // Match language lookup field
        const languageObject = LookupService.matchLookupObject(
            form.language,
            languages
        );
        if (languageObject) {
            form.language = languageObject;
        }

        // Match family history "who" fields
        const familyWhoFields = [
            'asthmaFamilyWho', 'tuberculosisFamilyWho', 'pneumoniaFamilyWho', 'covid19FamilyWho',
            'cancerFamilyWho', 'osteoarthritisFamilyWho', 'osteoporosisFamilyWho', 'rheumatoidArthritisFamilyWho',
            'thyroidDiseaseFamilyWho', 'abdominalDiseasesFamilyWho', 'breastDiseasesFamilyWho',
            'diabetesFamilyWho', 'kidneyDiseaseFamilyWho', 'heartDiseaseFamilyWho', 'otherConditionFamilyWho'
        ];

        familyWhoFields.forEach(field => {
            if (form[field]) {
                const matchedObject = LookupService.matchLookupObject(form[field], relationshipTypes);
                if (matchedObject) {
                    form[field] = matchedObject;
                }
            }
        });
    }

    retrievePatientPhoto = () => {
        const {consentFormCode: code} = this.props;

        RemotingService.getRemoteCall(
            `api/public/consent-form/code/${code}/patient-photo`,
            null,
            (profilePhoto) => {
                this.setState({
                    photoValue: profilePhoto,
                    newPhotoValue: profilePhoto,
                });
            }
        );
    };

    close = () => {
        confirmDialog(
            "Confirmation",
            "Are you sure you want to close this form? All input will be lost.",
            this.props.close
        );
    };

    submitForm = () => {
        if (ValidationUtil.checkWithNotification(this.formFields)) {
            const {consentFormCode: code, form} = this.props;
            this.updatePatientSignature(form);
            this.updateWitnessSignature(form);
            this.updateNabidhConsent(form);
            RemotingService.postRemoteCall(
                `api/public/consent-form/code/${code}/new-patient-form-rad`,
                form
            );
            this.props.onFormSubmit(form);
        }
    };

    updatePatientSignature = (form) => {
        form.consentForIntakeFormRad.patientSignature = this.state.patientSignature;
        form.consentForInformedConsentRad.patientSignature = this.state.patientSignature;
        form.cancellationPolicyDxb.patientSignature = this.state.patientSignature;
    };

    updateWitnessSignature = (form) => {
        form.consentForInformedConsentRad.witnessSignature = this.state.witnessSignature;
    };

    updateNabidhConsent = (form) => {
        const patientFullName = PatientUtil.getPatientName(
            form.consentForIntakeFormRad.firstName,
            form.consentForIntakeFormRad.middleName,
            form.consentForIntakeFormRad.lastName
        );
        const patientMrn = form.consentForIntakeFormRad.patientMrn || "";

        form.nabidhConsent = {
            consentType: this.state.nabidhConsentAction,
            patientSignature: this.state.nabidhPatientSignature,
            witnessName: this.state.nabidhWitnessName,
            witnessSignature: this.state.nabidhWitnessSignature,
            relationshipToPatient: this.state.nabidhRelationshipToPatient,
            patientFullName: patientFullName,
            patientMrn: patientMrn,
            patientDOB: form.consentForIntakeFormRad.dob || null
        };
    };

    createHeader = (form, selectedLanguage) => {
        let headerClass = selectedLanguage === "Arabic"
            ? "arabic-form d-flex justify-content-between align-items-center"
            : "d-flex justify-content-between align-items-center";
        return (
            <div style={{padding: "0px 20px 0px 20px"}}>
                <div className="row text-left">
                    <div className="col-12 no-padding">
                        <ClinicLogo/>
                    </div>
                </div>
                <div className="row">
                    <div
                        className="col-12 text-center no-padding"
                        style={{fontSize: 20, fontWeight: "bold"}}
                    >
                        {IntakeFormRadTextEnum.New_Patient_Form_Rad_Header[selectedLanguage]}
                    </div>
                </div>
            </div>
        );
    };

    fieldChanged = (fieldName, value, validationCallback) => {
        const {form} = this.props;
        
        if (this.isIntakeFormField(fieldName)) {
            form.consentForIntakeFormRad[fieldName] = value;
        } else if (this.isInformedConsentField(fieldName)) {
            form.consentForInformedConsentRad[fieldName] = value;
        }

        if (validationCallback) {
            validationCallback(this);
        }
        this.forceUpdate();
    };

    isIntakeFormField = (fieldName) => {
        const intakeFields = [
            'firstName', 'middleName', 'lastName', 'dob', 'age', 'gender', 'idNo', 'nationality',
            'maritalStatus', 'religion', 'language', 'phoneNumber', 'whatsappNumber', 'email',
            'address', 'country', 'city', 'postalCode', 'haveAllergies', 'allergy',
            'howHeardAboutClinic', 'referringPhysician', 'reasonForImaging',
            'emergencyContactName', 'emergencyContactRelationshipType', 'emergencyContactPhone',
            'markAllSelf', 'markAllFamily',
            'asthmaSelf', 'asthmaFamily', 'tuberculosisSelf', 'tuberculosisFamily',
            'pneumoniaSelf', 'pneumoniaFamily', 'covid19Self', 'covid19Family',
            'cancerSelf', 'cancerFamily', 'osteoarthritisSelf', 'osteoarthritisFamily',
            'osteoporosisSelf', 'osteoporosisFamily', 'rheumatoidArthritisSelf', 'rheumatoidArthritisFamily',
            'thyroidDiseaseSelf', 'thyroidDiseaseFamily', 'abdominalDiseasesSelf', 'abdominalDiseasesFamily',
            'breastDiseasesSelf', 'breastDiseasesFamily', 'diabetesSelf', 'diabetesFamily',
            'kidneyDiseaseSelf', 'kidneyDiseaseFamily', 'heartDiseaseSelf', 'heartDiseaseFamily',
            'otherConditionSelf', 'otherConditionFamily',
            'asthmaFamilyWho', 'tuberculosisFamilyWho', 'pneumoniaFamilyWho', 'covid19FamilyWho',
            'cancerFamilyWho', 'osteoarthritisFamilyWho', 'osteoporosisFamilyWho', 'rheumatoidArthritisFamilyWho',
            'thyroidDiseaseFamilyWho', 'abdominalDiseasesFamilyWho', 'breastDiseasesFamilyWho',
            'diabetesFamilyWho', 'kidneyDiseaseFamilyWho', 'heartDiseaseFamilyWho', 'otherConditionFamilyWho',
            'onMedicationSupplements', 'medicationDetails', 'everHadSurgery', 'surgeryDetails',
            'currentlyReceivingHealthcare', 'healthcareDetails', 'hadPreviousImaging', 'previousImagingDetails',
            'exerciseType', 'smokesCurrent', 'smokesHistory', 'consumesAlcohol',
            'currentlyPregnant', 'lastMenstrualPeriod', 'lastMenstrualPeriodDetails',
            'hadContrastDyeLast6Days', 'calciumVitaminDToday', 'calciumVitaminDLast24Hours',
            'nuclearMedicineScanBariumLast6Days', 'dexaScanLast12Months', 'fastingForUltrasoundXray'
        ];
        return intakeFields.includes(fieldName);
    };

    isInformedConsentField = (fieldName) => {
        const consentFields = [
            'pregnancyStatus', 'modalityType', 'witnessName', 'guardianName', 'guardianRelationship', 'genderAcknowledgment'
        ];
        return consentFields.includes(fieldName);
    };

    fieldGroupChanged = (fieldGroupObject, value, validationCallback) => {
        const {form} = this.props;
        
        Object.keys(fieldGroupObject).forEach(fieldName => {
            if (this.isIntakeFormField(fieldName)) {
                form.consentForIntakeFormRad[fieldName] = fieldGroupObject[fieldName];
            } else if (this.isInformedConsentField(fieldName)) {
                form.consentForInformedConsentRad[fieldName] = fieldGroupObject[fieldName];
            }
        });

        if (validationCallback) {
            validationCallback(this);
        }
        this.forceUpdate();
    };

    onSavePatientSignature = (signature) => {
        this.setState({patientSignature: signature});
    };

    onSaveWitnessSignature = (signature) => {
        this.setState({witnessSignature: signature});
    };

    onSaveNabidhPatientSignature = (signature) => {
        this.setState({nabidhPatientSignature: signature});
    };

    onSaveNabidhWitnessSignature = (signature) => {
        this.setState({nabidhWitnessSignature: signature});
    };

    handleNabidhConsentActionChange = (value) => {
        this.setState({nabidhConsentAction: value});
    };

    pushFormFieldRef = (ref) => this.formFields.push(ref);

    render() {
        const {form, language: selectedLanguage} = this.props;
        const photoValue = this.state.photoValue;
        const photoSrc = photoValue
            ? `data:image/jpeg;base64,${photoValue.content}`
            : `${process.env.PUBLIC_URL}/assets/patient_profile.png`;

        const formBodyClass = selectedLanguage === "Arabic" ? "arabic-form" : "";
        const maxWidthClass = "form-body";
        const enumLabel = selectedLanguage === "Arabic" ? "nameInArabic" : "name";
        const nationalityLabel = selectedLanguage === "Arabic" ? "nameInArabic" : "nameInEnglish";
        const patientName = PatientUtil.getPatientName(
            form.consentForIntakeFormRad.firstName,
            form.consentForIntakeFormRad.middleName,
            form.consentForIntakeFormRad.lastName
        );
        const mrnNo = form.consentForIntakeFormRad.patientMrn || "";
        
        this.formFields = [];

        const commonProps = {
            selectedLanguage,
            enumLabel,
            nationalityLabel,
            readOnly: false,
            onChange: this.fieldChanged,
            onFieldGroupChanged: this.fieldGroupChanged,
            formFields: this.formFields,
            pushFormFieldRef: this.pushFormFieldRef
        }

        const commonInformedConsentProps = {
            selectedLanguage,
            pushFormFieldRef: this.pushFormFieldRef
        }

        return (
            <Wizard
                fullScreen={true}
                className="WizardModal"
                show={true}
                close={this.close}
                title={this.createHeader(form, selectedLanguage)}
                onSubmit={this.submitForm}
                isReadOnly={false}
                previousBtnText={IntakeFormRadTextEnum.Wizard_Previous[selectedLanguage]}
                nextBtnText={IntakeFormRadTextEnum.Wizard_Next[selectedLanguage]}
                saveBtnText={IntakeFormRadTextEnum.Wizard_Save[selectedLanguage]}
            >
                {/* Page 1: Personal & Contact Information */}
                <Wizard.Page
                    onNext={(event) => ValidationUtil.stopEventPropagationIfValidationFails(event, this.formFields)}>
                    <div style={{width: "1000px"}}>
                        <div style={{padding: "20px", textAlign: "center", marginBottom: "20px"}}>
                            <img 
                                src={photoSrc} 
                                alt="Patient"
                                style={{width: "100px", height: "100px", borderRadius: "50%", objectFit: "cover"}}
                            />
                            <h4 className="mt-2">{IntakeFormRadTextEnum.New_Patient_Form_Rad_Title[selectedLanguage]}</h4>
                        </div>

                        <div className={formBodyClass}>
                            <IntakeFormRadPersonalInformation {...commonProps}
                                                              firstName={form.consentForIntakeFormRad.firstName}
                                                              middleName={form.consentForIntakeFormRad.middleName}
                                                              lastName={form.consentForIntakeFormRad.lastName}
                                                              dob={form.consentForIntakeFormRad.dob}
                                                              age={form.consentForIntakeFormRad.age}
                                                              gender={form.consentForIntakeFormRad.gender}
                                                              idNo={form.consentForIntakeFormRad.idNo}
                                                              nationality={form.consentForIntakeFormRad.nationality}
                                                              nationalities={this.props.nationalities}
                                                              maritalStatus={form.consentForIntakeFormRad.maritalStatus}
                                                              maritalStatuses={this.props.maritalStatuses}
                                                              religion={form.consentForIntakeFormRad.religion}
                                                              religions={this.props.religions}
                                                              language={form.consentForIntakeFormRad.language}
                                                              languages={this.props.languages}
                                                              haveAllergies={form.consentForIntakeFormRad.haveAllergies}
                                                              allergy={form.consentForIntakeFormRad.allergy}
                                                              allergyTypes={this.props.allergyTypes}
                                                              allergenTypes={this.props.allergenTypes}
                                                              allergySeverities={this.props.allergySeverities}
                                                              allergenReactionTypes={this.props.allergenReactionTypes}
                                                              onAllergyChanged={() => this.forceUpdate()}
                            />

                            <IntakeFormRadContactInformation {...commonProps}
                                                             phoneNumber={form.consentForIntakeFormRad.phoneNumber}
                                                             whatsappNumber={form.consentForIntakeFormRad.whatsappNumber}
                                                             email={form.consentForIntakeFormRad.email}
                                                             address={form.consentForIntakeFormRad.address}
                                                             country={form.consentForIntakeFormRad.country}
                                                             countries={this.props.countries}
                                                             city={form.consentForIntakeFormRad.city}
                                                             postalCode={form.consentForIntakeFormRad.postalCode}
                            />
                        </div>
                    </div>
                </Wizard.Page>

                {/* Page 2: Referral & Emergency Contact Information */}
                <Wizard.Page
                    onNext={(event) => ValidationUtil.stopEventPropagationIfValidationFails(event, this.formFields)}
                    onPrevious={() => this.formFields = []}>
                    <div className={formBodyClass + " my-2"} style={{width: "1000px"}}>
                        <IntakeFormRadReferralInformation {...commonProps}
                                                          howHeardAboutClinic={form.consentForIntakeFormRad.howHeardAboutClinic}
                                                          referringPhysician={form.consentForIntakeFormRad.referringPhysician}
                                                          reasonForImaging={form.consentForIntakeFormRad.reasonForImaging}
                        />

                        <IntakeFormRadEmergencyContact {...commonProps}
                                                       emergencyContactName={form.consentForIntakeFormRad.emergencyContactName}
                                                       emergencyContactRelationshipType={form.consentForIntakeFormRad.emergencyContactRelationshipType}
                                                       emergencyContactPhone={form.consentForIntakeFormRad.emergencyContactPhone}
                        />
                    </div>
                </Wizard.Page>

                {/* Page 3: Health History */}
                <Wizard.Page
                    onNext={(event) => ValidationUtil.stopEventPropagationIfValidationFails(event, this.formFields)}
                    onPrevious={() => this.formFields = []}>
                    <div className={formBodyClass + " my-2"} style={{width: "1000px"}}>
                        <IntakeFormRadHealthHistory {...commonProps}
                                                    markAllSelf={form.consentForIntakeFormRad.markAllSelf}
                                                    markAllFamily={form.consentForIntakeFormRad.markAllFamily}
                                                    asthmaSelf={form.consentForIntakeFormRad.asthmaSelf}
                                                    asthmaFamily={form.consentForIntakeFormRad.asthmaFamily}
                                                    tuberculosisSelf={form.consentForIntakeFormRad.tuberculosisSelf}
                                                    tuberculosisFamily={form.consentForIntakeFormRad.tuberculosisFamily}
                                                    pneumoniaSelf={form.consentForIntakeFormRad.pneumoniaSelf}
                                                    pneumoniaFamily={form.consentForIntakeFormRad.pneumoniaFamily}
                                                    covid19Self={form.consentForIntakeFormRad.covid19Self}
                                                    covid19Family={form.consentForIntakeFormRad.covid19Family}
                                                    cancerSelf={form.consentForIntakeFormRad.cancerSelf}
                                                    cancerFamily={form.consentForIntakeFormRad.cancerFamily}
                                                    osteoarthritisSelf={form.consentForIntakeFormRad.osteoarthritisSelf}
                                                    osteoarthritisFamily={form.consentForIntakeFormRad.osteoarthritisFamily}
                                                    osteoporosisSelf={form.consentForIntakeFormRad.osteoporosisSelf}
                                                    osteoporosisFamily={form.consentForIntakeFormRad.osteoporosisFamily}
                                                    rheumatoidArthritisSelf={form.consentForIntakeFormRad.rheumatoidArthritisSelf}
                                                    rheumatoidArthritisFamily={form.consentForIntakeFormRad.rheumatoidArthritisFamily}
                                                    thyroidDiseaseSelf={form.consentForIntakeFormRad.thyroidDiseaseSelf}
                                                    thyroidDiseaseFamily={form.consentForIntakeFormRad.thyroidDiseaseFamily}
                                                    abdominalDiseasesSelf={form.consentForIntakeFormRad.abdominalDiseasesSelf}
                                                    abdominalDiseasesFamily={form.consentForIntakeFormRad.abdominalDiseasesFamily}
                                                    breastDiseasesSelf={form.consentForIntakeFormRad.breastDiseasesSelf}
                                                    breastDiseasesFamily={form.consentForIntakeFormRad.breastDiseasesFamily}
                                                    diabetesSelf={form.consentForIntakeFormRad.diabetesSelf}
                                                    diabetesFamily={form.consentForIntakeFormRad.diabetesFamily}
                                                    kidneyDiseaseSelf={form.consentForIntakeFormRad.kidneyDiseaseSelf}
                                                    kidneyDiseaseFamily={form.consentForIntakeFormRad.kidneyDiseaseFamily}
                                                    heartDiseaseSelf={form.consentForIntakeFormRad.heartDiseaseSelf}
                                                    heartDiseaseFamily={form.consentForIntakeFormRad.heartDiseaseFamily}
                                                    otherConditionSelf={form.consentForIntakeFormRad.otherConditionSelf}
                                                    otherConditionFamily={form.consentForIntakeFormRad.otherConditionFamily}

                                                    asthmaFamilyWho={form.consentForIntakeFormRad.asthmaFamilyWho}
                                                    tuberculosisFamilyWho={form.consentForIntakeFormRad.tuberculosisFamilyWho}
                                                    pneumoniaFamilyWho={form.consentForIntakeFormRad.pneumoniaFamilyWho}
                                                    covid19FamilyWho={form.consentForIntakeFormRad.covid19FamilyWho}
                                                    cancerFamilyWho={form.consentForIntakeFormRad.cancerFamilyWho}
                                                    osteoarthritisFamilyWho={form.consentForIntakeFormRad.osteoarthritisFamilyWho}
                                                    osteoporosisFamilyWho={form.consentForIntakeFormRad.osteoporosisFamilyWho}
                                                    rheumatoidArthritisFamilyWho={form.consentForIntakeFormRad.rheumatoidArthritisFamilyWho}
                                                    thyroidDiseaseFamilyWho={form.consentForIntakeFormRad.thyroidDiseaseFamilyWho}
                                                    abdominalDiseasesFamilyWho={form.consentForIntakeFormRad.abdominalDiseasesFamilyWho}
                                                    breastDiseasesFamilyWho={form.consentForIntakeFormRad.breastDiseasesFamilyWho}
                                                    diabetesFamilyWho={form.consentForIntakeFormRad.diabetesFamilyWho}
                                                    kidneyDiseaseFamilyWho={form.consentForIntakeFormRad.kidneyDiseaseFamilyWho}
                                                    heartDiseaseFamilyWho={form.consentForIntakeFormRad.heartDiseaseFamilyWho}
                                                    otherConditionFamilyWho={form.consentForIntakeFormRad.otherConditionFamilyWho}

                                                    onMedicationSupplements={form.consentForIntakeFormRad.onMedicationSupplements}
                                                    medicationDetails={form.consentForIntakeFormRad.medicationDetails}
                                                    everHadSurgery={form.consentForIntakeFormRad.everHadSurgery}
                                                    surgeryDetails={form.consentForIntakeFormRad.surgeryDetails}
                                                    currentlyReceivingHealthcare={form.consentForIntakeFormRad.currentlyReceivingHealthcare}
                                                    healthcareDetails={form.consentForIntakeFormRad.healthcareDetails}
                                                    hadPreviousImaging={form.consentForIntakeFormRad.hadPreviousImaging}
                                                    previousImagingDetails={form.consentForIntakeFormRad.previousImagingDetails}
                                                    exerciseType={form.consentForIntakeFormRad.exerciseType}
                                                    smokesCurrent={form.consentForIntakeFormRad.smokesCurrent}
                                                    smokesHistory={form.consentForIntakeFormRad.smokesHistory}
                                                    consumesAlcohol={form.consentForIntakeFormRad.consumesAlcohol}
                                                    currentlyPregnant={form.consentForIntakeFormRad.currentlyPregnant}
                                                    lastMenstrualPeriod={form.consentForIntakeFormRad.lastMenstrualPeriod}
                                                    lastMenstrualPeriodDetails={form.consentForIntakeFormRad.lastMenstrualPeriodDetails}
                                                    hadContrastDyeLast6Days={form.consentForIntakeFormRad.hadContrastDyeLast6Days}
                                                    calciumVitaminDToday={form.consentForIntakeFormRad.calciumVitaminDToday}
                                                    calciumVitaminDLast24Hours={form.consentForIntakeFormRad.calciumVitaminDLast24Hours}
                                                    nuclearMedicineScanBariumLast6Days={form.consentForIntakeFormRad.nuclearMedicineScanBariumLast6Days}
                                                    dexaScanLast12Months={form.consentForIntakeFormRad.dexaScanLast12Months}
                                                    fastingForUltrasoundXray={form.consentForIntakeFormRad.fastingForUltrasoundXray}
                        />
                    </div>
                </Wizard.Page>

                {/* Page 4: Informed Consent for Radiology */}
                <Wizard.Page
                    onNext={(event) => ValidationUtil.stopEventPropagationIfValidationFails(event, this.formFields)}
                    onPrevious={() => this.formFields = []}>
                    <div className={`${formBodyClass} ${maxWidthClass}`}>
                        <ConsentFormPartsRad.Title selectedLanguage={selectedLanguage}/>
                        <ConsentFormPartsRad.RadiologyProcedureConsent selectedLanguage={selectedLanguage}/>
                        <ConsentFormPartsRad.ModalityTypeSelection
                            {...commonInformedConsentProps}
                            modalityType={form.consentForInformedConsentRad.modalityType}
                            readOnly={false}
                            formFields={this.formFields}
                            onChange={this.fieldChanged}
                        />
                        <ConsentFormPartsRad.RadiationRiskDeclaration
                            {...commonInformedConsentProps}
                            pregnancyStatus={form.consentForInformedConsentRad.pregnancyStatus}
                            readOnly={false}
                            formFields={this.formFields}
                            onChange={this.fieldChanged}
                        />
                        <ConsentFormPartsRad.RemoteRadiologyConsent selectedLanguage={selectedLanguage}/>
                        <ConsentFormPartsRad.DataCollectionAndPrivacy selectedLanguage={selectedLanguage}/>
                        <ConsentFormPartsRad.PatientRights selectedLanguage={selectedLanguage}/>
                        <ConsentFormPartsRad.QuestionsAndConcerns selectedLanguage={selectedLanguage}/>
                        <ConsentFormPartsRad.Complaints selectedLanguage={selectedLanguage}/>
                        <ConsentFormPartsRad.FinalConsent selectedLanguage={selectedLanguage}/>
                        <ConsentFormPartsRad.HealthcareProviderGenderAcknowledgment 
                            selectedLanguage={selectedLanguage}
                            genderAcknowledgment={form.consentForInformedConsentRad.genderAcknowledgment}
                            onGenderAcknowledgmentChange={(value) => this.fieldChanged("genderAcknowledgment", value)}
                            readOnly={false}
                            pushFormFieldRef={this.pushFormFieldRef}
                        />

                        <div>
                            <InformedConsentSignatureInputs {...commonInformedConsentProps}
                                                            readOnly={false}
                                                            formFields={this.formFields}
                                                            textEnum={InformedConsentFormRadTextEnum}
                                                            consentDate={moment(new Date()).format('LL')}
                                                            patientName={`${form.consentForIntakeFormRad.firstName} ${form.consentForIntakeFormRad.middleName || ''} ${form.consentForIntakeFormRad.lastName}`.trim()}
                                                            providerName={form.consentForInformedConsentRad.providerName}
                                                            guardianName={form.consentForInformedConsentRad.guardianName}
                                                            guardianRelationship={form.consentForInformedConsentRad.guardianRelationship}
                                                            patientSignature={this.state.patientSignature}
                                                            providerSignature={form.consentForInformedConsentRad.providerSignature}
                                                            onSavePatientSignature={this.onSavePatientSignature}
                                                            onChange={this.fieldChanged}/>
                        </div>

                        <ConsentFormPartsRad.WitnessStatement 
                            selectedLanguage={selectedLanguage}
                            consentDate={moment(new Date()).format('LL')}
                            witnessName={form.consentForInformedConsentRad.witnessName}
                            witnessSignature={this.state.witnessSignature}
                            onWitnessNameChange={(value) => this.fieldChanged("witnessName", value)}
                            onWitnessSignatureChange={this.onSaveWitnessSignature}
                            readOnly={false}
                            formFields={this.formFields}
                            pushFormFieldRef={this.pushFormFieldRef}
                        />
                    </div>
                </Wizard.Page>

                {/* Page 5: Cancellation Policy */}
                <Wizard.Page 
                    onNext={(event) => ValidationUtil.stopEventPropagationIfValidationFails(event, this.formFields)}
                    onPrevious={() => this.formFields = []}>
                    <div className={`${formBodyClass} ${maxWidthClass}`}>
                        <h3 className="text-center mb-4">
                            <b>{CancellationPolicyDxbTextEnum.Cancellation_Policy_Public_Title[selectedLanguage]}</b>
                        </h3>
                        <CancellationPolicyPartsDxb.Part1 selectedLanguage={selectedLanguage}/>
                        <div style={{border: "1px solid #000000", borderRadius: "35px"}}>
                            <CancellationPolicyPartsDxb.Part2 selectedLanguage={selectedLanguage}/>
                        </div>
                        <div className="mt-4">
                            <CancellationPolicyPartsDxb.Part3 
                                selectedLanguage={selectedLanguage}
                                patientName={patientName}
                            />
                        </div>
                    </div>
                </Wizard.Page>

                {/* Page 6: NABIDH Consent Form - Information & Patient Signature */}
                <Wizard.Page
                    onNext={(event) => ValidationUtil.stopEventPropagationIfValidationFails(event, this.formFields)}
                    onPrevious={() => this.formFields = []}>
                    <div className={`${formBodyClass} ${maxWidthClass}`}>
                        <h3 className="text-center mb-4">
                            <b>{NabidhFormTextEnum.Nabidh_Consent_Form_Title[selectedLanguage]}</b>
                        </h3>
                        <NabidhConsentFormParts.PatientInformation
                            selectedLanguage={selectedLanguage}
                            patientName={patientName}
                            mrnNo={mrnNo}
                            patientDOB={form.consentForIntakeFormRad.dob}
                        />
                        <NabidhConsentFormParts.NabidhInformation selectedLanguage={selectedLanguage}/>

                        <NabidhConsentFormParts.PatientSignatureSection
                            selectedLanguage={selectedLanguage}
                            readOnly={false}
                            consentDate={form.consentForIntakeFormRad.consentDate || new Date()}
                            patientName={patientName}
                            patientSignature={this.state.nabidhPatientSignature}
                            onSavePatientSignature={this.onSaveNabidhPatientSignature}
                            pushFormFieldRef={this.pushFormFieldRef}
                        />
                    </div>
                </Wizard.Page>

            </Wizard>
        );
    }
}

function mapStateToProps(state) {
    return {
        nationalities: state.base.lookupNationalities,
        countries: state.base.lookupCountries,
        relationshipTypes: state.base.relationshipTypes,
        maritalStatuses: state.base.lookupMaritalStatuses,
        religions: state.base.lookupReligions,
        languages: state.base.lookupLanguages,
        allergyTypes: state.base.allergyTypes,
        allergenTypes: state.base.allergenTypes,
        allergySeverities: state.base.allergySeverities,
        allergenReactionTypes: state.base.allergenReactionTypes
    };
}

export default connect(mapStateToProps)(PublicNewPatientFormRad);